import { Component, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { TopbarComponent } from '../topbar/topbar.component';
import { SidebarMenuComponent } from '../sidebar-menu/sidebar-menu.component';
import { BreadcrumbService } from '../../core/services/breadcrumb.service';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-mainpage',
  templateUrl: './mainpage.component.html',
  styleUrls: ['./mainpage.component.scss'],
  imports: [RouterOutlet, TopbarComponent, SidebarMenuComponent, CommonModule, RouterModule],
})
export class MainpageComponent implements OnInit {
  breadcrumbs: any = [];




  breadcrumbs$!: Observable<any[]>;
  pageTitle$!: Observable<string>;

  constructor(private breadcrumbService: BreadcrumbService) {
    this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;
    this.pageTitle$ = this.breadcrumbService.pageTitle$;
  }

  ngOnInit(): void {
    //    this.breadcrumbService.breadcrumbs$.subscribe(res => {
    //   this.breadcrumbs = res;
    // });

  }

}
